<template>
  <div :class="$style.box">
    <Scroll ref="scroll" :class="$style.wrapper">
      <div>
        <!-- 详情页帖子信息 -->
        <div :class="$style.topic">
          <div :class="$style['topic-title']" v-html="topicDetail.title"></div>
          <!-- 楼主信息 -->
          <div :class="$style.poster">
            <HeadImage
              :headImage="topicDetail.forum_image"
              :headCircleImage="topicDetail.identity_image"
            />
            <div :class="$style['poster-info']">
              <div :class="$style['poster-identity']">
                <p>{{ topicDetail.forum_name }}</p>
              </div>
              <p>{{ topicDetail.created_at }}</p>
            </div>
          </div>
          <!-- 帖子正文部分 -->
          <div
            ref="topicContent"
            :class="$style['topic-content']"
            v-html="topicMainContent"
            v-lazy-container="{
              selector: 'img',
            }"
          ></div>
          <p :class="$style.word">{{ `关注“【${word}】”微信公众号， 进入游戏论坛，参与回帖` }}</p>
        </div>
      </div>
    </Scroll>
  </div>
</template>

<script>
import Scroll from '_c/Scroll';
import HeadImage from '_c/HeadImage';
import { getDetailTopicInfoPreview } from '@/api/preview';
import { letslazyload } from '@/utils/index.js';

export default {
  components: {
    HeadImage,
    Scroll,
  },
  data() {
    return {
      topicDetail: {}, // 帖子信息
      topicMainContent: '', // 帖子正文
    };
  },
  created() {
    this.getDetailTopicInfo();
  },
  mounted() {
    // if (this.type == 1) {
    //   window.changeBaseSize && window.changeBaseSize(75);
    // } else {
    //   window.changeBaseSize && window.changeBaseSize(130);
    // }
    setTimeout(() => {
      this.onresize();
      window.onorientationchange = function () {};
    }, 100);
  },
  beforeDestroy() {
    // window.resetBaseSize && window.resetBaseSize();
  },
  computed: {
    // 帖子id
    conversationId() {
      return this.$route.query.id;
    },
    // 横竖屏
    type() {
      return this.$route.query.type;
    },
    // 底部加的词汇
    word() {
      return this.$route.query.word;
    },
  },
  methods: {
    onresize() {
      const html = document.documentElement;
      // 当前页面宽度相对于 375 宽的缩放比例，可根据自己需要修改。
      let scale = html.clientWidth / 375;
      let baseSize = 75;
      if (window.orientation == 180 || window.orientation == 0) {
        scale = html.clientWidth / 375;
      }
      if (window.orientation == 90 || window.orientation == -90) {
        scale = html.clientWidth / 667;
        baseSize = 130;
      }
      // 设置页面根节点字体大小
      html.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
    },
    // 获取帖子详情
    async getDetailTopicInfo() {
      const r = await getDetailTopicInfoPreview({
        conversation_id: this.conversationId,
      });
      this.topicDetail = { ...r.data };
      if (!this.topicDetail.content) {
        this.topicMainContent = '';
        return;
      }
      // 给正文中添加的链接加一个点击事件
      if (this.topicDetail.content.indexOf('<a href') !== -1) {
        let el = document.createElement('div');
        el.innerHTML = this.topicDetail.content;
        let aList = el.getElementsByTagName('a');
        for (const item of aList) {
          this.topicDetail.content = this.topicDetail.content.replace(
            '<a',
            `<a onclick="window.location.href='${item.href}'"`,
          );
        }
      }
      // 替换后台编辑框中默认修改的图片样式
      let reg =
        /img style="width:auto; height:350px;|img style="width: auto; height: 350px;/gi;
      this.topicDetail.content = this.topicDetail.content.replace(
        reg,
        'img style="width: 100%; height: auto;',
      );
      this.topicMainContent = letslazyload(this.topicDetail.content);
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-x: hidden;
}
.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
}
.topic {
  width: 100%;
  padding: 30px 17px 17px 17px;
  .topic-title {
    width: 100%;
    min-height: 30px;
    text-align: left;
    line-height: 30px;
    font-size: 18px;
    font-weight: bold;
  }
  .poster {
    margin-top: 15px;
    width: 348px;
    display: flex;
    .poster-info {
      position: relative;
      left: -8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .poster-identity {
        width: 189px;
        line-height: 14px;
        font-size: 15px;
        p:first-child {
          font-weight: bold;
        }
      }
      > p {
        margin-top: 12px;
        float: left;
        width: 169px;
        height: 8px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(159, 159, 159, 1);
      }
    }
    .poster-btn {
      position: relative;
      left: 35px;
      > button {
        @include clearBtnDefaultStyle;
        margin-top: 13px;
        width: fit-content;
        height: 17px;
        text-align: center;
        font-size: 10px;
        font-weight: 400;
        color: rgba(40, 169, 251, 1);
        border: 1px solid rgba(40, 169, 251, 1);
        border-radius: 9px;
      }
    }
  }
  .topic-content {
    margin-top: 9px;
    width: 340px;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    overflow: hidden;
    white-space: pre-line;
    img {
      width: 100%;
      height: auto;
      margin: 5px auto;
    }
    // 使用属性选择器选择表情图片
    img[src*='plugins/emoticons'] {
      width: 18px;
      height: 18px;
      margin: 0;
    }
  }
  .word {
    margin-top: 15px;
    line-height: 26px;
    padding: 0px 10px;
    background-color: #f9eff2;
    color: #ff5955;
  }
  .advertising {
    width: 340px;
    height: 66px;
    margin-top: 14px;
    background: rgba(237, 237, 237, 1);
    border-radius: 7px;
    padding: 6px 10px 6px 7px;
    font-size: 12px;
    & > img {
      width: 54px;
      float: left;
      margin-right: 12px;
    }
    .advertising-info {
      width: 170px;
      float: left;
      margin-top: 9px;
      font-weight: 400;
      & > p:nth-child(1) {
        font-size: 13px;
        color: rgba(0, 0, 0, 1);
        line-height: 13px;
      }
      & > p:nth-child(2) {
        color: rgba(159, 159, 159, 1);
        font-size: 11px;
        line-height: 13px;
        margin-top: 9px;
      }
    }
    .advertising-btn {
      @include clearBtnDefaultStyle;
      width: 68px;
      line-height: 31px;
      background: linear-gradient(-75deg, rgba(255, 73, 73, 1), rgba(255, 143, 94, 1));
      border-radius: 15px;
      float: right;
      font-size: 12px;
      font-weight: 400;
      color: white;
      text-align: center;
      margin-top: 12px;
    }
  }
}
.comments {
  .comments-btn {
    position: absolute;
    z-index: 30;
    right: 15px;
    margin-top: 10px;
    @include clearBtnDefaultStyle;
    font-size: 14px;
    color: rgba(40, 169, 251, 1);
  }
}
.empty {
  width: 100%;
  height: 300px;
  > div {
    position: relative;
    top: 43px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    margin-bottom: 13px;
    width: 100%;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: rgba(159, 159, 159, 1);
    line-height: 13px;
  }
  > img {
    position: relative;
    top: 43px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    width: 218px;
    height: auto;
  }
}
.scale {
  width: 375px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  > img {
    width: 100%;
    height: auto;
  }
  .slide {
    width: 100vw;
    height: 100vh;
  }
}
</style>
